import styled from 'styled-components'

export const Paragraph = styled.p`
  margin-bottom: 0.8rem;
  & > .muted {
    color: ${({ theme }) => theme.colors.metalGray};
  }
`
